import { IRoute } from "../../../common/helpers/routesMapper";
import withRouter from "../../utils/withRouter";
import { connect } from "react-redux";
import injectIntl from "../../../common/helpers/injectIntl";
import { Store } from "redux";

import { seo } from "../../../common/helpers/seo";
import getPlanSeo from "../../../common/helpers/getPlanSeo";
import { IPlan } from "../../../common/types";

import resetPlan from "../../store/plan/actions/resetPlan";
import getPlan from "../../store/plan/actions/getPlan";
import { IStateTree } from "../../store/interfaces";
import { IUser } from "../../store/user/models";
import routing from "../../routing";
import lazyComponent from "./lazy";

const mapStateToProps = ({ plan, user }: IStateTree) => ({
    plan: plan as IPlan,
    user: user as IUser,
});

const mapDispatchToProps = { getPlan, resetPlan };

export default {
    component: withRouter(injectIntl(connect(mapStateToProps, mapDispatchToProps)(lazyComponent))),
    loadData: ({ dispatch }: any, path: string) => dispatch(getPlan(path)),
    renderSeo: ({ getState }: Store<IStateTree>, allMessage: {[key: string]: string}, lang: string, path: string) => {
        const { plan } = getState();
        if (!plan || (plan as {
            loading?: boolean,
            error?: boolean,
            notFound?: boolean,
        }).error) {
            return seo({
                title: allMessage.notFound,
                type: "article",
                noindex: true,
                nofollow: true,
                allMessage,
                lang,
            });
        }
        const publicView =
            path.slice(1, routing.publicPlan.length + 1) === routing.publicPlan ||
            path.slice(1, routing.testModeration.length + 1) === routing.testModeration;
        const planSeo = getPlanSeo((plan as IPlan), { locale: lang }, publicView, path);
        return seo({
            ...planSeo,
            noindex: true,
            nofollow: true,
            allMessage,
            lang,
        });
    },
} satisfies IRoute;
